import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { getOrderProfit, profitMoney } from '../../../../utils/orderProfit';
import { orderItemKey } from '../../../../utils/orderItemKeys';
import { formatMarginPercent } from '../../../../utils/margin';
import '../../../../styles/order-profit.css';

export default function OrderProfit({ order }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(false);
  }, [order.orderId]);
  const totals = useMemo(() => getOrderProfit(order), [order]);
  const showCommission = totals.lines.some(line => line.commission !== 0);
  const profitLabel = `${profitMoney(totals.profit)}${
    totals.marginPercent == null ? '' : ` (${formatMarginPercent(totals.marginPercent)})`
  }`;
  const resultClass =
    totals.profit < 0 ? 'text-danger' : totals.profit > 0 ? 'text-success' : 'text-muted';
  const field = (label, amount) => (
    <div>
      <dt>{label}</dt>
      <dd>{profitMoney(amount)}</dd>
    </div>
  );

  return (
    <>
      <button
        type='button'
        className={`order-profit-toggle ${resultClass}`}
        onClick={() => setShow(true)}
        aria-haspopup='dialog'
        title='Показати деталізацію заробітку. Відсоток — від фактичної суми продажу після всіх знижок.'
      >
        <svg
          className='mr-1'
          width='18'
          height='18'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2.2'
          strokeLinecap='round'
          strokeLinejoin='round'
          aria-hidden='true'
          focusable='false'
        >
          <path d='M3 3v18h18M7 15l5-5 4 3 5-7' />
        </svg>
        <span>Заробіток:</span> <strong>{profitLabel}</strong>
        <i className='bi bi-info-circle ml-1' aria-hidden='true' />
      </button>
      {show && (
        <Modal
          show
          onHide={() => setShow(false)}
          size='lg'
          centered
          animation={false}
          className='order-profit-modal'
          aria-labelledby={`order-profit-title-${order.orderId}`}
        >
          <Modal.Header closeButton>
            <Modal.Title as='h5' id={`order-profit-title-${order.orderId}`}>
              Заробіток із замовлення #{order.orderId}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-sm order-profit-table'>
                <thead>
                  <tr>
                    <th scope='col'>Товар</th>
                    <th scope='col'>К-сть</th>
                    <th scope='col'>Продаж після знижок</th>
                    <th scope='col'>Собівартість</th>
                    {showCommission && <th scope='col'>Комісія Прому</th>}
                    <th scope='col'>Заробіток</th>
                    <th
                      scope='col'
                      title='Заробіток із позиції / фінальна сума продажу позиції після знижок × 100%. Доставка врахована в підсумку замовлення.'
                    >
                      Маржа
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {totals.lines.map(line => (
                    <tr key={orderItemKey(line.item)}>
                      <td>
                        {line.item.name}
                        {line.item.productCode && (
                          <small className='d-block text-muted'>{line.item.productCode}</small>
                        )}
                      </td>
                      <td>{line.quantity}</td>
                      <td>{profitMoney(line.revenue)}</td>
                      <td>{profitMoney(line.cost)}</td>
                      {showCommission && <td>{profitMoney(line.commission)}</td>}
                      <td>{profitMoney(line.profit)}</td>
                      <td className='font-weight-bold text-success'>
                        {formatMarginPercent(line.marginPercent)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <dl className='order-profit-breakdown'>
              {totals.adjustment !== 0 && field('Коригування суми замовлення', totals.adjustment)}
              {field('Продаж після всіх знижок', totals.revenue)}
              {totals.cost !== 0 && field('Собівартість товарів', -totals.cost)}
              {totals.commission !== 0 && field('Комісія Прому', -totals.commission)}
              {totals.delivery !== 0 && field('Витрати на доставку', -totals.delivery)}
              <div className={`order-profit-result ${resultClass}`}>
                <dt>Загальний заробіток</dt>
                <dd>{profitLabel}</dd>
              </div>
            </dl>
          </Modal.Body>
          <Modal.Footer>
            <button type='button' className='btn btn-secondary' onClick={() => setShow(false)}>
              Закрити
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
